import { ApplicationPolicy } from '@/policies/ApplicationPolicy'

export abstract class ReviewsPolicy extends ApplicationPolicy {
  public static manageReviews(): boolean {
    return this.hasReviewsManagementAccess()
  }

  public static viewReviewsProductLeads(): boolean {
    return this.hasReviewsManagementAccess()
  }

  public static viewReviewsAgencyLeads(): boolean {
    return this.hasReviewsManagementAccess()
  }

  public static viewReviewsAd(): boolean {
    return this.hasOnlyReviewsRoles()
  }
}

export enum ReviewsAbilities {
  manageReviews = 'manageReviews',
  viewReviewsProductLeads = 'viewReviewsProductLeads',
  viewReviewsAgencyLeads = 'viewReviewsAgencyLeads',
  viewReviewsAd = 'viewReviewsAd',
}
